import { combineReducers } from 'redux';
import MTCNSearchReducer from './mtcn-search-reducer';
import DFDTSearchReducer from './dfdt-search-reducer';

export default function reducers() {
    return combineReducers({
        MTCNSearchReducer,
        DFDTSearchReducer,
    })
}